const breakpoints = [768, 1024, 1444, 1920];

(($, Drupal) => {
  const adjustFontSize = (textEl) => {
    const parentEl = textEl.parentNode;

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === parentEl) {
          for (let index = 0; index < breakpoints.length; index++) {
            const breakpoint = breakpoints[index];
            const maxWidth = breakpoints[index + 1];

            if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches && window.matchMedia(`(max-width: ${maxWidth}px)`)) {
              const { scrollWidth, clientWidth } = parentEl;
              const matchedBreakpoint = breakpoint;

              if (clientWidth >= scrollWidth) {
                textEl.removeAttribute('style');
              } else {
                const fontSize = window.getComputedStyle(textEl, null).getPropertyValue('font-size');
                textEl.style.transition = 'font-size 200ms';
                textEl.style.fontSize = `${parseFloat(fontSize) * 0.75}px`;
                textEl.setAttribute('data-prev-font-size', JSON.stringify({ fontSize, breakpoint }));
              }

              const prev = textEl.getAttribute('data-prev-font-size');
              const formatted = JSON.parse(prev);

              if (formatted && matchedBreakpoint === formatted.breakpoint) {
                textEl.style.fontSize = `${parseFloat(formatted.fontSize) * 0.75}px`;
              }
            }
          }
        }
      });
    });

    resizeObserver.observe(parentEl);
  };

  Drupal.behaviors.mstFontsizeAdjustment = {
    attach(context) {
      $('.adjust-font-size', context).each((index, element) => adjustFontSize(element));
    },
  };
})(jQuery, Drupal);
